import React, { useCallback, useState } from 'react';
import { IText } from 'fabric';
import { Trash2 } from 'lucide-react';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { useOnSelectionChange } from '../hooks/use-on-selection-change';
import { ToolbarSeparator } from '../../shared/ui/toolbar-separator';
import { ToolBtn } from '../../shared/ui/tool-btn';
import { FontControls } from '../components/text-settings/font-controls';
import { AlignControls } from '../components/text-settings/align-controls';
import { ColorControl } from '../components/text-settings/color-control';
import { AnimationSelector } from '../../animations/components/animation-selector';
import { isSobreimpresoTextbox, SobreimpresoTextbox } from './types';
import { SobreimpresoFillControl } from './fill-control';
import { SobreimpresoNumberInputs } from './number-inputs';

function useIsEditing(s: SobreimpresoTextbox | null): boolean {
  const [isEditing, setIsEditing] = useState(!!s?.isEditing);
  const read = useCallback(() => setIsEditing(!!s?.isEditing), [s]);
  useOnSelectionChange(s, read);
  return isEditing;
}

export const SobreimpresoSettings: React.FC = () => {
  const { canvas, selectedObject, deleteSelected } = useEditorCanvas();
  const s = isSobreimpresoTextbox(selectedObject) ? selectedObject : null;
  const isEditing = useIsEditing(s);

  if (!canvas || !s) return null;

  if (isEditing) {
    return (
      <>
        <FontControls textObject={s as IText} canvas={canvas} />
        <ToolbarSeparator />
        <AlignControls textObject={s as IText} canvas={canvas} />
        <ToolbarSeparator />
        <ColorControl textObject={s as IText} canvas={canvas} />
      </>
    );
  }

  return (
    <>
      <SobreimpresoFillControl s={s} />
      <ToolbarSeparator />
      <SobreimpresoNumberInputs s={s} />
      <ToolbarSeparator />
      <AnimationSelector />
      <ToolbarSeparator />
      <ToolBtn onClick={deleteSelected} variant='danger' title='Eliminar'>
        <Trash2 size={15} />
      </ToolBtn>
    </>
  );
};
